import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
  postData: {},
};

const postPAFormThreeSlice = createSlice({
  name: "postPAFormThree",
  initialState,
  reducers: {
    postPAFormThreeStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postPAFormThreeSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.postMessage = action.payload.postMessage;
    },
    postPAFormThreeDataSuccess(state, action) {
      state.postData = action.payload;
    },
    postPAFormThreeFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postPAFormThreeStart,
  postPAFormThreeSuccess,
  postPAFormThreeDataSuccess,
  postPAFormThreeFailure,
  clearError,
  clearMessage,
} = postPAFormThreeSlice.actions;

export default postPAFormThreeSlice.reducer;
